<template>
  <v-dialog v-bind:value="show" @click:outside="$emit('close')" fullscreen scrollable>
    <v-card>
      <v-card-title class="headline">
        <v-icon left color="info">help_outline</v-icon>
        Guía de Cheques
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text style="max-height: 75vh;">
        <!-- CICLO CHEQUES -->
        <div class="text-center my-3">
          <img src="@/assets/images/ciclo_cheques.png" alt="Ciclo de Cheques" style="max-width:100%; height:auto;" />
        </div>

        <v-divider class="mb-4"></v-divider>

        <!-- ACCIONES -->
        <p class="subtitle-1 font-weight-bold mb-2">Acciones disponibles</p>

        <v-expansion-panels accordion flat>

          <!-- DEPOSITAR -->
          <v-expansion-panel>
            <v-expansion-panel-header class="font-weight-medium">
              <span><v-icon small color="blue" class="mr-2">arrow_downward</v-icon>Depositar</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-simple-table dense>
                <tbody>
                  <tr><td class="font-weight-medium" width="200">Aplica a</td><td>Cheques de <strong>tercero</strong></td></tr>
                  <tr><td>Estado requerido</td><td><code>EN_CARTERA</code></td></tr>
                  <tr><td>Estado resultante</td><td><code>DEPOSITADO</code></td></tr>
                  <tr><td>Cuenta resultante</td><td>VDP — Valores a Depositar</td></tr>
                  <tr><td>Movimiento</td><td>D: VDP &nbsp;|&nbsp; H: CCH (Cheques en Cartera)</td></tr>
                  <tr><td>Requerimientos</td><td>Seleccionar cuenta bancaria destino</td></tr>
                </tbody>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- ACREDITAR -->
          <v-expansion-panel>
            <v-expansion-panel-header class="font-weight-medium">
              <span><v-icon small color="green" class="mr-2">check_circle</v-icon>Acreditar</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-simple-table dense>
                <tbody>
                  <tr><td class="font-weight-medium" width="200">Aplica a</td><td>Cheques de <strong>tercero</strong></td></tr>
                  <tr><td>Estado requerido</td><td><code>DEPOSITADO</code></td></tr>
                  <tr><td>Estado resultante</td><td><code>ACREDITADO</code></td></tr>
                  <tr><td>Cuenta resultante</td><td>Cuenta bancaria seleccionada (tipo CTA_CTE)</td></tr>
                  <tr><td>Movimiento</td><td>D: Cta. Bancaria &nbsp;|&nbsp; H: VDP (Valores a Depositar)</td></tr>
                  <tr><td>Requerimientos</td><td>Seleccionar cuenta corriente bancaria</td></tr>
                </tbody>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- DEBITAR -->
          <v-expansion-panel>
            <v-expansion-panel-header class="font-weight-medium">
              <span><v-icon small color="orange" class="mr-2">remove_circle</v-icon>Debitar</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-simple-table dense>
                <tbody>
                  <tr><td class="font-weight-medium" width="200">Aplica a</td><td>Cheques <strong>propios</strong></td></tr>
                  <tr><td>Estado requerido</td><td><code>UTILIZADO</code></td></tr>
                  <tr><td>Estado resultante</td><td><code>DEBITADO</code></td></tr>
                  <tr><td>Cuenta resultante</td><td>AXC — Acreedores por Compras (sin cambio)</td></tr>
                  <tr><td>Movimiento</td><td>D: VDB (Valores a Debitar) &nbsp;|&nbsp; H: Cta. Bancaria (cuenta padre de la Chequera)</td></tr>
                  <tr><td>Requerimientos</td><td>Ninguno adicional (la cuenta se resuelve automáticamente desde la chequera)</td></tr>
                </tbody>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- COBRAR POR VENTANILLA -->
          <v-expansion-panel>
            <v-expansion-panel-header class="font-weight-medium">
              <span><v-icon small color="teal" class="mr-2">store</v-icon>Cobrar por ventanilla</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-simple-table dense>
                <tbody>
                  <tr><td class="font-weight-medium" width="200">Aplica a</td><td>Cheques de <strong>tercero</strong></td></tr>
                  <tr><td>Estado requerido</td><td><code>EN_CARTERA</code></td></tr>
                  <tr><td>Estado resultante</td><td><code>COBRADO_VENTANILLA</code></td></tr>
                  <tr><td>Cuenta resultante</td><td>Cuenta seleccionada por el usuario</td></tr>
                  <tr><td>Movimiento</td><td>BankMovement directo (sin TesoreriaMovement)</td></tr>
                  <tr><td>Requerimientos</td><td>Seleccionar cuenta destino</td></tr>
                </tbody>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- NEGOCIAR -->
          <v-expansion-panel>
            <v-expansion-panel-header class="font-weight-medium">
              <span><v-icon small color="purple" class="mr-2">swap_horiz</v-icon>Negociar</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-simple-table dense>
                <tbody>
                  <tr><td class="font-weight-medium" width="200">Aplica a</td><td>Cheques de <strong>tercero</strong></td></tr>
                  <tr><td>Estado requerido</td><td><code>EN_CARTERA</code></td></tr>
                  <tr><td>Estado resultante</td><td><code>NEGOCIADO</code></td></tr>
                  <tr><td>Cuenta resultante</td><td>Cuenta bancaria seleccionada</td></tr>
                  <tr><td>Movimiento</td><td>D: Cta. Bancaria &nbsp;|&nbsp; H: CCH (Cheques en Cartera)</td></tr>
                  <tr><td>Requerimientos</td><td>Seleccionar cuenta bancaria</td></tr>
                </tbody>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- RECHAZAR -->
          <v-expansion-panel>
            <v-expansion-panel-header class="font-weight-medium">
              <span><v-icon small color="red" class="mr-2">block</v-icon>Rechazar</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-simple-table dense>
                <tbody>
                  <tr><td class="font-weight-medium" width="220">Acción individual (por fila)</td><td>Sí — botón <v-icon small>block</v-icon> visible en cada fila cuando el estado lo permite</td></tr>
                </tbody>
              </v-simple-table>
              <v-simple-table dense class="mt-2">
                <thead>
                  <tr>
                    <th>Tipo</th>
                    <th>Estado previo</th>
                    <th>Estado resultante</th>
                    <th>Cuenta resultante</th>
                    <th>Movimiento</th>
                    <th>ND al cliente (<code>nd_id</code>)</th>
                    <th>ND al proveedor (<code>spent_nd_id</code>)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Propio</td>
                    <td><code>UTILIZADO</code></td>
                    <td><code>RECHAZADO</code></td>
                    <td>VRP — Valores Rechazados Propios</td>
                    <td>D: VRP &nbsp;|&nbsp; H: AXC</td>
                    <td>❌ No requerida</td>
                    <td>✅ Requerida</td>
                  </tr>
                  <tr>
                    <td>Tercero</td>
                    <td><code>ACREDITADO</code></td>
                    <td><code>RECHAZADO</code></td>
                    <td>VRT — Valores Rechazados Terceros</td>
                    <td>Reversión acreditación (D: VDP &nbsp;|&nbsp; H: Banco) + Rechazo (D: VRT &nbsp;|&nbsp; H: VDP)</td>
                    <td>✅ Requerida</td>
                    <td>❌ No requerida</td>
                  </tr>
                  <tr>
                    <td>Tercero</td>
                    <td><code>UTILIZADO</code></td>
                    <td><code>RECHAZADO</code></td>
                    <td>VRT — Valores Rechazados Terceros</td>
                    <td>D: VRT &nbsp;|&nbsp; H: AXC</td>
                    <td>✅ Requerida</td>
                    <td>✅ Requerida</td>
                  </tr>
                </tbody>
              </v-simple-table>
              <p class="caption mt-2 orange--text text--darken-2">
                Las Notas de Débito deben tener el importe exacto del cheque.
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>          

        </v-expansion-panels>

        <v-divider class="my-4"></v-divider>

        <!-- TABLA DE CUENTAS -->
        <p class="subtitle-1 font-weight-bold mb-2">Referencia de cuentas</p>
        <v-simple-table dense>
          <thead>
            <tr>
              <th>Código</th>
              <th>Nombre</th>
              <th>Uso</th>
            </tr>
          </thead>
          <tbody>
            <tr><td><code>CCH</code></td><td>Cheques en Cartera</td><td>Cheques de tercero en posesión</td></tr>
            <tr><td><code>Chequera</code></td><td>Cuenta hija de la cuenta bancaria</td><td>Cheques propios emitidos</td></tr>
            <tr><td><code>VDP</code></td><td>Valores a Depositar</td><td>Cheques de tercero depositados pendientes de acreditación</td></tr>
            <tr><td><code>VDB</code></td><td>Valores a Debitar</td><td>Cheques propios pendientes de débito bancario</td></tr>
            <tr><td><code>VRP</code></td><td>Valores Rechazados Propios</td><td>Cheques propios rechazados</td></tr>
            <tr><td><code>VRT</code></td><td>Valores Rechazados Terceros</td><td>Cheques de tercero rechazados</td></tr>
            <tr><td><code>VVP</code></td><td>Valores Vencidos Propios</td><td>Cheques propios vencidos</td></tr>
            <tr><td><code>VVT</code></td><td>Valores Vencidos Terceros</td><td>Cheques de tercero vencidos</td></tr>
            <tr><td><code>AXC</code></td><td>Acreedores por Compras</td><td>Deuda con proveedor al entregar cheque propio</td></tr>
            <tr><td><code>DXV</code></td><td>Deudores por Ventas</td><td>Deuda del cliente al recibir cheque de tercero</td></tr>
          </tbody>
        </v-simple-table>

      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('close')">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: Boolean,
  },
};
</script>
